import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/tenant/privacy/tenant.privacy.state.query.gql"
import type {
  TenantPrivacyStateQuery,
  TenantPrivacyStateQueryVariables,
} from "@/v2-backoffice-client/tenant/privacy/__types__/tenant.privacy.state.query"

type Options = QueryHookOptions<
  TenantPrivacyStateQuery,
  TenantPrivacyStateQueryVariables
>

export function useTenantPrivacyStateQuery(options?: Options) {
  return useQuery<TenantPrivacyStateQuery, TenantPrivacyStateQueryVariables>(
    query,
    options,
  )
}
